/** 해외사역지 상세 지도 — API 키 없이 구글 지도 embed(iframe) 사용 */
export default function OverseasGoogleMap({ address }: { address: string }) {
  if (!address.trim()) {
    return <div className="map-fallback">주소 정보가 없어 지도를 표시할 수 없습니다.</div>;
  }

  return (
    <iframe
      className="map-canvas"
      title="구글 지도"
      src={`https://maps.google.com/maps?q=${encodeURIComponent(address)}&z=14&output=embed`}
      style={{ border: 0 }}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      allowFullScreen
    />
  );
}
